module.exports = __webpack_public_path__ + "img/share-coupon4.f3432808.png";